import { Box } from '@chakra-ui/react';

import PageMetatags from '../../layout/PageMetatags';
import LegalDocumentsOverview from './LegalDocumentsOverview';

const LegalDocumentsPage = () => {
  return (
    <Box>
      <PageMetatags title="Legal documents" />
      <LegalDocumentsOverview />
    </Box>
  );
};

export default LegalDocumentsPage;
